export const areas = {
  searchAreas: {
    method: "get",
    url: "/areas",
  },
};
